import script from "./StoreStaffRanking.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreStaffRanking.vue?vue&type=script&setup=true&lang=js"

import "./StoreStaffRanking.vue?vue&type=style&index=0&id=720933f6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-720933f6"]])

export default __exports__